import {defineStore} from 'pinia'

// @ts-ignore
export const useKpiBookStore = defineStore('kpi-book', {
  state: () => ({
    pathPrefix: '/kpi-book'
  }),
  getters: {},
  actions: {
    // /**
    //  * 이달의 미팅 신청
    //  * @param payload
    //  * @returns {Promise<void>}
    //  */
    // async postMembershipMonthlyApplication(payload) {
    //   const {$apiClient} = useNuxtApp()
    //   const path = `${this.pathPrefix}/meeting`
    //   return await $apiClient(path, {
    //     method: 'POST',
    //     body: {
    //       membershipMonthlyInfoId: payload.membershipMonthlyInfoId,
    //       companyName: payload.companyName,
    //       participant: payload.participant
    //     }
    //   })
    // },
    async getKpiBookList() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getKpiBookDetail(bookId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/${bookId}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    /**
     * 포토존 게시글 상세 조회
     * @returns {Promise<void>}
     */
    async getMonthlySeminarList(type) {
      const {$apiClient} = useNuxtApp()
      const query = `?type=${type}`
      const path = `${this.pathPrefix}/monthly${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 교육강좌 조회
     * @returns {Promise<void>}
     */
    async getSeminarList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?type=${payload.type}&page=${payload.page}&limit=${payload.limit}&status=${payload.status}`
      const path = `${this.pathPrefix}${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 교육강좌 상세 조회
     * @returns {Promise<void>}
     */
    async getSeminarDetail(seminarId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/${seminarId}`
      return await $apiClient(path, {
        method: 'GET'
      })
    }
  }
})
